import { ReportHeader } from "@/components/report-header";
import { EmptyState } from "@/components/ui/empty-state";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { ViewSelector } from "@/components/view-selector";
import { SavedViewProvider } from "@/contexts/saved-view-context";
import { useSalesperson } from "@/hooks/api/use-salespeople";
import { useIncludeBids } from "@/hooks/use-include-bids";
import { usePageTitle } from "@/hooks/use-page-title";
import { useSalespersonSelection } from "@/hooks/use-salesperson-selection";
import { useTouchpointTypeSelection } from "@/hooks/use-touchpoint-type-selection";
import { SalespersonScorecard } from "./salesperson-scorecard";
import { SalespersonSelector } from "./salesperson-selector";

export default function SalespersonExplorer() {
  const pageType = "salespeople::explorer";
  const { selectedPersonId } = useSalespersonSelection();
  const { data: salesperson, isLoading: isSalespersonLoading } = useSalesperson(
    selectedPersonId || "",
  );
  // selectedTypes no longer used directly; scorecard computes effective types
  useTouchpointTypeSelection(selectedPersonId || null);
  const { includeBids, setIncludeBids } = useIncludeBids();

  // Set page title based on selected salesperson
  usePageTitle(
    salesperson
      ? `${salesperson.name} - Salesperson Report`
      : "Salesperson Report Card",
  );

  return (
    <SavedViewProvider pageType={pageType}>
      <div className="flex flex-col space-y-4">
        <ReportHeader
          title="Rep Report Card"
          primary={
            <div className="flex flex-wrap gap-2">
              <SalespersonSelector />
            </div>
          }
          right={
            selectedPersonId && !isSalespersonLoading && salesperson ? (
              <ViewSelector pageType={pageType} />
            ) : undefined
          }
        />

        {isSalespersonLoading ? null : !selectedPersonId ? (
          <EmptyState
            title="Select a salesperson"
            description="Select a salesperson from the dropdown above to view their report card."
          />
        ) : (
          <Tabs defaultValue="scorecard" className="w-full">
            <div className="flex items-center border-b">
              <TabsList className="border-b-0">
                <TabsTrigger value="scorecard" className="relative">
                  <div className="flex items-center gap-1.5">Scorecard</div>
                </TabsTrigger>
              </TabsList>
            </div>

            <TabsContent value="scorecard" className="mt-6">
              <SalespersonScorecard
                personId={selectedPersonId}
                includeBids={includeBids}
                onIncludeBidsChange={setIncludeBids}
              />
            </TabsContent>
          </Tabs>
        )}
      </div>
    </SavedViewProvider>
  );
}
